module.exports = __webpack_public_path__ + "static/media/demo_class_video_student_only_II.3828dc19.jpg";